import React from "react";
import { Redirect, Link } from "react-router-dom";
import {
	Container,
	Paper,
	Typography,
	TextField,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { useStore } from "../../store/StoreProvider";
import { observer } from "mobx-react";
import CustomButton from "../../shared/Button";

const useFormStyles = makeStyles((theme: Theme) => ({
	paper: {
		padding: "48px 0",
    width: "520px",
    borderRadius: '20px',
    [theme.breakpoints.down('xs')]: {
      borderRadius: '0',
      width: '100%'
    }
	},
	formContainer: {
    padding: "0 102px 0 98px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px'
    }
  },
  fieldsWrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  fieldsDivider: {
    minWidth: '8px'
  },
  form: {
    marginBottom: '24px'
  },
	buttonContainer: {
		display: "flex",
		justifyContent: "flex-end",
		marginTop: "30px"
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '2.75rem',
    fontSize: '1.65rem'
  },
  btn: {
    marginTop: '72px'
  }
}));

const LoginForm: React.FC = () => {
  const store = useStore(); 
	const [userInfo, setUserInfo] = React.useState({
		email: "",
		password: ""
	});
  const classes = useFormStyles();
	const onSubmit = (event: React.FormEvent) => {
		event.preventDefault();
		store.login(userInfo);
	};

	const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target;
  
		setUserInfo({ ...userInfo, [input.name]: input.value });
	};

	if (store.isLoggedIn) {
		return <Redirect to="/main" />;
	}

	return (
		<Paper className={classes.paper} elevation={5}>
			<Container className={classes.formContainer}>
				<Typography variant="h4" className={classes.title}>
					Войти
				</Typography>
				<form onSubmit={onSubmit} className={classes.form}>
					<TextField
						label="Имя пользователя"
						type="email"
						name="email"
            value={userInfo.email}
            placeholder='mail@mail.ru'
						onChange={onInputChange}
						inputProps={{ "data-testid": "inputName" }}
						margin="normal"
						fullWidth
						required
					/>
					<TextField
						label="Пароль"
						type="password"
            name="password"
            placeholder="*********"
						value={userInfo.password}
						onChange={onInputChange}
						inputProps={{ "data-testid": "inputPassword" }}
						margin="normal"
						fullWidth
						required
					/>
          <CustomButton fullWidth classname={classes.btn} type='submit' testId='buttonLogin'>
            Войти
          </CustomButton>
				</form>
        <div>
					<Typography>
						Новый пользователь?{" "}
						<Link to="/registration" style={{ textDecoration: 'none', color: '#FDBF5A' }}>
							Зарегистрируйтесь
						</Link>
					</Typography>
				</div>
			</Container>
		</Paper>
	);
};

export default observer(LoginForm);
